const id = {
  "app.tagline": "Marketplace Game Online Premium",
  "nav.marketplace": "Marketplace",
  "nav.orders": "Pesanan",
  "nav.dashboard": "Dashboard",
  "nav.chat": "Pesan",
  "nav.login": "Masuk",
  "nav.register": "Daftar",
  "nav.logout": "Keluar",
  "nav.stock": "Stok",
  "nav.suppliers": "Supplier",
  "nav.reports": "Laporan",
  "nav.settings": "Pengaturan",
  "nav.submit_stock": "Ajukan Stok",
  "nav.admin": "Kelola",
  "nav.account": "Akun",
  "nav.supplier_prices": "Harga Supplier",
  "nav.members": "Pengguna",
  "landing.hero.title": "Perdagangan Game Online Terpercaya",
  "landing.hero.sub": "Koin, akun, item, dan jasa boosting dari MQL Group. Transaksi aman, pengiriman cepat.",
  "landing.cta.browse": "Jelajahi Produk",
  "landing.cta.register": "Daftar Sekarang",
  "landing.f1.title": "Transaksi Aman",
  "landing.f1.desc": "Pembayaran diverifikasi oleh tim MQL Group",
  "landing.f2.title": "Pengiriman Cepat",
  "landing.f2.desc": "Rata-rata pengiriman di bawah 30 menit",
  "landing.f3.title": "Supplier Terverifikasi",
  "landing.f3.desc": "Stok hanya dari supplier yang lolos KYC",
  "landing.f4.title": "Pelayanan Premium",
  "landing.f4.desc": "Dukungan chat 24/7 dari staff ahli",
  "auth.email": "Email",
  "auth.password": "Password",
  "auth.name": "Nama",
  "auth.role": "Daftar sebagai",
  "auth.role.buyer": "Pembeli",
  "auth.role.supplier": "Supplier",
  "auth.login": "Masuk",
  "auth.register": "Daftar",
  "auth.have_account": "Sudah punya akun?",
  "auth.no_account": "Belum punya akun?",
  "auth.forgot": "Lupa password?",
  "auth.welcome_back": "Selamat datang kembali",
  "auth.welcome": "Selamat datang",
  "auth.login_failed": "Login gagal",
  "auth.register_failed": "Pendaftaran gagal",
  "auth.accept_prefix": "Saya sudah membaca dan menyetujui",
  "auth.policy.buyer": "Kebijakan Buyer",
  "auth.policy.supplier": "Kebijakan Supplier",
  "kyc.notice": "Supplier wajib verifikasi KYC. Akun bisa dipakai setelah Admin menyetujui KTP Anda. Foto hanya dilihat Owner & Staff.",
  "kyc.telegram": "Username Telegram",
  "kyc.whatsapp": "Nomor WhatsApp",
  "kyc.contact_hint": "Isi minimal salah satu: Telegram atau WhatsApp, supaya Admin mudah menghubungi Anda.",
  "kyc.ktp": "Foto KTP",
  "kyc.ktp_hint": "Seluruh KTP terlihat jelas, tidak buram.",
  "kyc.selfie": "Selfie dengan KTP",
  "kyc.selfie_hint": "Wajah dan KTP terlihat jelas dalam satu foto.",
  "kyc.sent_title": "Pendaftaran terkirim",
  "kyc.sent_body": "Data KYC Anda sedang diperiksa Admin. Anda akan menerima email saat akun disetujui, lalu bisa login.",
  "market.search": "Cari produk...",
  "market.filters": "Filter",
  "market.all_games": "Semua Game",
  "market.all_categories": "Semua Kategori",
  "market.price_range": "Rentang Harga",
  "market.in_stock": "Hanya Tersedia",
  "market.buy": "Beli",
  "market.detail": "Detail",
  "market.stock": "Stok",
  "market.all_servers": "Semua Server",
  "market.all_regions": "Semua Region",
  "market.all_factions": "Semua Faction",
  "market.min_price": "Harga min (IDR)",
  "market.max_price": "Harga maks (IDR)",
  "market.apply": "Terapkan",
  "market.reset": "Reset",
  "market.err_minmax": "Harga minimum lebih besar dari maksimum",
  "market.load_failed": "Gagal memuat produk",
  "product.description": "Deskripsi",
  "product.add_to_order": "Pesan Sekarang",
  "product.quantity": "Jumlah",
  "product.stock_after": "Sisa stok setelah beli",
  "product.qty_decrease": "Kurangi jumlah",
  "product.qty_increase": "Tambah jumlah",
  "product.qty_max": "Maks",
  "product.not_found": "Produk tidak ditemukan",
  "product.not_found_sub": "Produk ini sudah tidak tersedia atau telah dihapus.",
  "product.back": "Kembali ke Marketplace",
  "product.login_first": "Silakan login dulu",
  "product.buyers_only": "Hanya pembeli yang bisa memesan",
  "product.invalid_qty": "Jumlah tidak valid",
  "product.order_created": "Pesanan dibuat",
  "product.order_failed": "Gagal membuat pesanan",
  "checkout.title": "Informasi Pesanan",
  "checkout.sub": "Pilih metode pengiriman lalu periksa ringkasan sebelum konfirmasi.",
  "checkout.payment_method": "Metode Pembayaran",
  "checkout.notes": "Catatan pengiriman",
  "checkout.place_order": "Buat Pesanan",
  "checkout.total": "Total",
  "checkout.method": "Metode Pengiriman",
  "checkout.character": "Character Name",
  "checkout.account_id": "ID Akun / User ID",
  "checkout.auction_notes": "Detail listing (item, harga, waktu)",
  "checkout.product": "Produk",
  "checkout.game_server": "Game / Server",
  "checkout.qty": "Jumlah",
  "checkout.unit_price": "Harga satuan",
  "checkout.fee": "Biaya tambahan",
  "checkout.payment": "Pembayaran",
  "checkout.grand_total": "Total pesanan",
  "checkout.use_balance": "Pakai Saldo Store",
  "checkout.balance_available": "Tersedia",
  "checkout.balance_used": "Dibayar dengan Saldo Store",
  "checkout.amount_due": "Total pembayaran",
  "checkout.usd_note": "Metode ini dibayar dalam USD dengan kurs yang dikunci saat pesanan dibuat.",
  "checkout.confirm": "Konfirmasi Pesanan",
  "checkout.processing": "Memproses...",
  "delivery.mail": "Mail / Surat",
  "delivery.mail.desc": "Item dikirim lewat mail in-game ke karakter Anda.",
  "delivery.trade": "Trade / Pengiriman Langsung",
  "delivery.trade.desc": "Staff MQL bertemu karakter Anda in-game dan melakukan trade.",
  "delivery.auction": "Auction House",
  "delivery.auction.desc": "Anda memasang item murah di Auction House, staff MQL membelinya sesuai nilai pesanan.",
  "delivery.topup": "Top-up langsung",
  "delivery.topup.desc": "Saldo dikirim langsung ke akun/ID game Anda.",
  "delivery.service": "Jasa oleh tim MQL",
  "delivery.service.desc": "Boosting/Power Leveling/Questing dikerjakan tim MQL. Detail login & jadwal dikoordinasikan aman lewat menu Pesan setelah pembayaran diverifikasi. Jangan kirim password di catatan.",
  "delivery.account_handover": "Serah terima akun",
  "delivery.account_handover.desc": "Data login akun dikirim staff lewat menu Pesan setelah pembayaran diverifikasi.",
  "order.status.waiting_payment": "Menunggu Pembayaran",
  "order.status.verifying": "Verifikasi Pembayaran",
  "order.status.preparing": "Menyiapkan",
  "order.status.shipped": "Dikirimkan",
  "order.status.completed": "Selesai",
  "order.status.cancelled": "Dibatalkan",
  "order.status.resolution": "Resolusi",
  "order.status.trade_ready": "Staff Siap Trade",
  "order.status.partial_delivery": "Pengiriman Bertahap",
  "order.upload_proof": "Unggah Bukti Pembayaran",
  "order.my_orders": "Pesanan Saya",
  "order.sales": "Pesanan Penjualan",
  "order.all": "Semua",
  "order.no": "No. Order",
  "order.date": "Tanggal",
  "order.items": "Items",
  "order.status": "Status",
  "order.detail": "Detail",
  "order.back": "← Kembali",
  "order.payment_proof": "Bukti Pembayaran",
  "order.history": "Riwayat Status",
  "order.payment": "Pembayaran",
  "order.delivery": "Pengiriman",
  "order.character": "Karakter / ID",
  "order.send": "Kirim",
  "order.proof_sent": "Bukti pembayaran terkirim",
  "order.upload_failed": "Gagal unggah",
  "order.max_5mb": "Maks 5MB",
  "order.trade_ready_badge": "Siap Trade",
  "order.trade_ready_title": "Staff siap trade sekarang",
  "order.trade_ready_char": "Silakan online di game dengan karakter",
  "order.shipped_title": "Item sudah dikirim",
  "order.progress": "Progres Pengiriman",
  "order.delivered": "terkirim",
  "order.refund": "Refund ke Saldo Store",
  "order.balance_used": "Dibayar dengan Saldo Store",
  "order.amount_due": "Total pembayaran",
  "order.unique_code": "Kode unik",
  "order.pay_within": "Bayar sebelum waktu habis, atau pesanan dibatalkan otomatis",
  "order.pay_expired": "Waktu bayar habis — pesanan sedang dibatalkan",
  "product.min_order": "Minimal pembelian",
  "product.min_order_err": "Minimal pembelian produk ini adalah {amount}",
  "order.transfer_exact": "Transfer PERSIS sesuai nominal di atas (sudah termasuk kode unik +{code}) agar pembayaran cepat dikenali.",
  "order.scan_qris": "Scan dengan aplikasi bank / e-wallet apa pun — nominal terisi otomatis.",
  "order.scan_usdt": "Scan dengan wallet kripto Anda untuk menyalin alamat.",
  "order.usdt_warning": "Kirim USDT hanya lewat jaringan TRON (TRC20). Jaringan lain akan hilang.",
  "order.usdt_network_warning": "Kirim hanya USDT melalui jaringan {network}. Pengiriman lewat jaringan lain bisa hilang.",
  "order.usdt_locked": "Kurs terkunci: 1 USDT = {rate} · Total {total}",
  "order.binance_scan": "Scan dengan aplikasi Binance (Pay) atau kirim ke UID di bawah",
  "order.binance_name": "Nama akun",
  "order.binance_exact": "Bayar tepat sesuai nominal USDT di atas, lalu unggah bukti pembayaran.",
  "checkout.usdt_note": "Dikonversi otomatis dengan kurs terbaru, dibulatkan ke atas 2 desimal. Kurs dikunci saat pesanan dibuat. 1 USDT = {rate}",
  "checkout.fx_changed": "Kurs baru saja diperbarui. Periksa nominal USDT terbaru lalu konfirmasi lagi.",
  "order.rate": "Kurs",
  "notif.title": "Notifikasi",
  "notif.empty": "Belum ada notifikasi",
  "balance.title": "Saldo Store",
  "balance.desc": "Refund bagian pesanan yang dibatalkan dan belum terkirim. Bisa dipakai untuk belanja berikutnya di MQL; tidak bisa ditarik tunai.",
  "balance.history": "Riwayat Saldo",
  "balance.refund": "Refund",
  "balance.payment": "Pembayaran",
  "footer.contact": "MQL Store — Informasi Kontak",
  "footer.phone": "Telepon",
  "policy.buyer": "Kebijakan Buyer",
  "policy.supplier": "Kebijakan Supplier",
  "policy.updated": "Versi",
  "policy.lang_note": "",
  "common.save": "Simpan",
  "common.cancel": "Batal",
  "common.confirm": "Konfirmasi",
  "common.actions": "Aksi",
  "common.loading": "Memuat...",
  "common.empty": "Belum ada data",
  "dashboard.new_orders": "Pesanan Baru",
  "dashboard.to_process": "Perlu Diproses",
  "dashboard.completed": "Selesai",
  "dashboard.total_sales": "Total Penjualan",
  "dashboard.stock_available": "Stok Tersedia",
  "dashboard.pending_reviews": "Review Stok",
  "chat.new": "Percakapan Baru",
  "chat.type_message": "Ketik pesan...",
  "chat.type_message_paste": "Ketik pesan... (Ctrl+V untuk tempel screenshot)",
  "chat.latest": "Pesan Terbaru",
  "chat.image_ready": "Gambar siap. Tekan kirim untuk mengirim.",
  "chat.send": "Kirim",
  "chat.attach_image": "Lampirkan Gambar",
  "chat.video_url": "URL Video",
  "chat.select": "Pilih percakapan",
  "acct.label": "AKUN",
  "acct.title": "Pengaturan Akun",
  "acct.profile": "Profil",
  "acct.role": "Peran",
  "role.owner": "Owner",
  "role.staff": "Staff",
  "role.supplier": "Supplier",
  "role.buyer": "Pembeli",
  "acct.change_pw": "Ganti Password",
  "acct.current_pw": "Password saat ini",
  "acct.new_pw": "Password baru (min. 8 karakter)",
  "acct.confirm_pw": "Ulangi password baru",
  "acct.save_pw": "Simpan Password Baru",
  "acct.saving": "Menyimpan...",
  "acct.pw_mismatch": "Konfirmasi password tidak sama",
  "acct.pw_changed": "Password diubah. Sesi di perangkat lain otomatis keluar.",
  "twofa.codes_copied": "Recovery codes disalin",
  "twofa.codes_note": "Simpan recovery codes ini di tempat aman. Setiap kode hanya bisa dipakai sekali jika HP Anda hilang. Kode ini tidak akan ditampilkan lagi.",
  "twofa.copy": "Salin",
  "twofa.saved": "Sudah saya simpan",
  "twofa.enable_start": "Aktifkan Google Authenticator",
  "twofa.step1": "1. Pindai QR ini dengan aplikasi Google Authenticator.",
  "twofa.manual": "Tidak bisa memindai? Masukkan kode ini secara manual:",
  "twofa.step2": "2. Masukkan kode 6 digit yang muncul di aplikasi.",
  "twofa.verify": "Verifikasi & Aktifkan",
  "twofa.code_label": "Kode Authenticator",
  "twofa.regen": "Buat recovery codes baru",
  "twofa.mandatory_note": "2FA wajib untuk akun Owner/Staff dan tidak bisa dimatikan. Jika HP staff hilang, Owner bisa mereset 2FA di Kelola → Akun Staff.",
  "twofa.disable": "Matikan 2FA",
  "twofa.disabled": "2FA dimatikan",
  "twofa.on": "2FA aktif — login wajib memakai kode Authenticator.",
  "twofa.required": "2FA wajib untuk akun Anda. Aktifkan sekarang untuk membuka menu Owner/Staff.",
  "twofa.off": "2FA belum aktif.",
  "twofa.enabled": "2FA aktif",
  "sound.title": "Bunyi Notifikasi",
  "sound.order": "Bunyi order",
  "sound.message": "Bunyi pesan",
  "sound.volume": "Volume",
  "sound.off": "Mati",
  "sound.chime": "Chime",
  "sound.bell": "Lonceng",
  "sound.coin": "Koin",
  "sound.ping": "Ping",
  "sound.test": "Tes",
  "sound.saved": "Pengaturan bunyi disimpan",
  "sound.custom_group": "Bunyi toko",
  "sound.autoplay_note": "Bunyi diputar selama website terbuka, setelah Anda klik di halaman (aturan browser).",
  "order.watch_video": "Tonton video bukti pengiriman",
  "order.chat_staff": "Chat dengan Staff",
  "maint.title": "Sedang Maintenance",
  "maint.countdown": "Maintenance terjadwal dimulai dalam",
  "maint.sub": "Kami sedang meningkatkan MQL Group. Akun, pesanan, dan Saldo Store Anda tetap aman.",
  "maint.staff_banner": "MODE MAINTENANCE AKTIF — pembeli & supplier tidak bisa membuka situs",
  "maint.staff_login": "Masuk Owner / Staff",
  "order.refund_title": "{amount} sudah dikembalikan ke Saldo Store Anda",
  "order.refund_body": "Dana Anda aman. Ini untuk bagian pesanan yang belum terkirim dan bisa langsung dipakai untuk belanja berikutnya.",
  "order.chat_failed": "Tidak bisa membuka chat",
};

export default id;
